// ExamFinancialRiskPage.tsx

import { useTranslation } from "react-i18next";
import { Analytics, ShowChart, AccountBalance } from "@mui/icons-material";
import { useTheme, alpha } from "@mui/material";
import quizApi from "@/services/quizService";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import type { BrandResolver } from "@/types/Portal.types";
import BaseExamPortalPage from "./BaseExamPortalPage";

const getFinancialRiskBrand =
  (isDark: boolean): BrandResolver =>
  (item) => {
    const name = item.quizName.toLowerCase();
    if (name.includes("part 1") || name.includes("part i")) {
      const accent = isDark ? "#f87171" : "#dc2626";
      return {
        icon: Analytics,
        accentColor: accent,
        gradient: `radial-gradient(circle at 90% 10%, ${alpha(accent, 0.15)} 0%, transparent 60%)`,
      };
    }
    if (name.includes("part 2") || name.includes("part ii")) {
      const accent = isDark ? "#ef4444" : "#b91c1c";
      return {
        icon: ShowChart,
        accentColor: accent,
        gradient: `radial-gradient(circle at 90% 10%, ${alpha(accent, 0.15)} 0%, transparent 60%)`,
      };
    }
    const accent = isDark ? "#FF99C8" : "#991b1b";
    return {
      icon: AccountBalance,
      accentColor: accent,
      gradient: `radial-gradient(circle at 90% 10%, ${alpha(accent, 0.15)} 0%, transparent 60%)`,
    };
  };

export default function ExamFinancialRiskPage() {
  const { t } = useTranslation();
  const navigate = useAppNavigate();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  return (
    <BaseExamPortalPage
      title={t("pages.examFinancialRisk.title")}
      subtitle={t("pages.examFinancialRisk.subtitle")}
      actionText={t("pages.examFinancialRisk.actionText")}
      themeConfig={{
        activeTabBg: theme.palette.primary.main,
        activeTabTextColor: theme.palette.primary.contrastText,
        borderColor: theme.palette.divider,
      }}
      fetchData={async () => {
        const res = await quizApi.getQuizzes({ search: "financial", limit: 99 });
        return res.data;
      }}
      brandResolver={getFinancialRiskBrand(isDark)}
      onItemSelect={(item) => navigate(`mock/quiz/${item.quizName}`)}
      isDisabled={true}
    />
  );
}
